import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';
import {
    PickupSchedule,
    LeaseQuoteItemModel,
    LeaseQuoteModel,
    DropoffSchedule,
    PickupScheduleError,
    DropoffScheduleError,
    EmptyRepoQuoteItemModel, EmptyRepoQuoteModel
} from '../quoteTable/lease-quote-table/lease-quote';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { LocationModel } from '../quoteTable/base-quote.model';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'logzy-pickup-dropoff-schedule-lease',
  templateUrl: './pickup-dropoff-schedule-lease.component.html',
  styleUrls: ['./pickup-dropoff-schedule-lease.component.scss']
})
export class PickupDropoffScheduleLeaseComponent implements OnInit {

  @Input() quoteList: LeaseQuoteItemModel[] | EmptyRepoQuoteItemModel[];

  @Input() scheduleList: LeaseQuoteModel | EmptyRepoQuoteModel;
  @Input() type: string = '';

  pickupDisplayColumnsParent: string[] = [];
  pickupDisplayColumns: string[] = [];
  dropoffDisplayColumns: string[] = [];

  disableSave: boolean = false;

  @Input() loading: boolean = false;
  editPickupDetailsTable: boolean[] = [];

  editIndex: number = -1;
  oldPickupValue: any;
  requestId: string = '';
  errorObj: any = {};
  showPickUpRow: boolean = false;

  pickupfilter: string = 'All';
  dropofffilter: string = 'All';
  pickupDataSource;
  dropoffDataSource;

  polList: LocationModel[];
  podList: LocationModel[];

  @Output() editPS = new EventEmitter<any>();
  @Output() editDS = new EventEmitter<any>();
  @ViewChild(MatTable) pickupTable: MatTable<PickupSchedule>;
  @ViewChild(MatTable) dropoffTable: MatTable<DropoffSchedule>;
  containerSizesPickup = [];
  containerSizesDropoff = [];

  isCustomer: boolean;

  constructor(
    // @Inject(MAT_DIALOG_DATA) public data: any,
    public requestService: RequestApiService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.isCustomer = this.authService.isCustomer();
    this.route.queryParams.subscribe(params => {
      if ('id' in params) {
        this.requestId = params['id'];
      }
    });

    if (this.scheduleList != null) {
      this.pickupDataSource = [...this.scheduleList.pickup_schedules];
      this.dropoffDataSource = [...this.scheduleList.dropoff_schedules];

      if (this.pickupDataSource != null) {
        this.pickupDataSource.sort((a, b) => {
          if (a.requirement.container_size_type.size < b.requirement.container_size_type.size) {
            return -1;
          } else if (a.requirement.container_size_type.size > b.requirement.container_size_type.size) {
            return 1;
          } else {
            return 0;
          }
        });

        this.containerSizesPickup.push('All');
        this.getContainerSizeTypes(this.pickupDataSource).map(item => this.containerSizesPickup.push(item));

        this.pickupDataSource.map(pickup => pickup.error = new PickupScheduleError());
      }

      if (this.dropoffDataSource != null) {
        this.dropoffDataSource.sort((a, b) => {
          if (a.requirement.container_size_type.size < b.requirement.container_size_type.size) {
            return -1;
          } else if (a.requirement.container_size_type.size > b.requirement.container_size_type.size) {
            return 1;
          } else {
            return 0;
          }
        });

        this.containerSizesDropoff.push('All');
        this.getContainerSizeTypes(this.dropoffDataSource).map(item => this.containerSizesDropoff.push(item));

        this.dropoffDataSource.map(dropoff => dropoff.error = new DropoffScheduleError());
      }

      console.log(this.pickupDataSource, this.dropoffDataSource);

    } else {
      this.pickupDataSource = [];
      this.dropoffDataSource = [];
    }

    if (this.isCustomer) {
      this.pickupDisplayColumns = ['display', 'display_name', 'per_month_permitted_quantity', 'total_permitted_quantity', 'handling_charge', 'pickup_charge', 'remarks'];
      this.dropoffDisplayColumns = ['display', 'display_name', 'per_month_permitted_quantity', 'total_permitted_quantity', 'handling_charge', 'dropoff_charge', 'remarks'];
    } else {
      this.pickupDisplayColumns = ['display', 'display_name', 'per_month_permitted_quantity', 'total_permitted_quantity', 'handling_charge', 'pickup_charge', 'remarks', 'actions'];
      this.dropoffDisplayColumns = ['display', 'display_name', 'per_month_permitted_quantity', 'total_permitted_quantity', 'handling_charge', 'dropoff_charge', 'remarks', 'actions'];
    }

    this.requestService.pickupScheduleListSubject.subscribe(item => {
      item.map(pickup => this.pickupDataSource.push(pickup));
      this.pickupDataSource.sort((a, b) => {
        if (a.requirement.container_size_type.size < b.requirement.container_size_type.size) {
          return -1;
        } else if (a.requirement.container_size_type.size > b.requirement.container_size_type.size) {
          return 1;
        } else {
          return 0;
        }
      });
      this.pickupTable.renderRows();
      this.containerSizesPickup = [];
      this.containerSizesPickup.push('All');
      this.getContainerSizeTypes(this.pickupDataSource).map(item => this.containerSizesPickup.push(item));
      console.log('this.requestService.pickupScheduleListSubject', this.pickupDataSource);
    });

    this.requestService.dropoffScheduleListSubject.subscribe(item => {
      item.map(dropoff => this.dropoffDataSource.push(dropoff));
      this.dropoffDataSource.sort((a, b) => {
        if (a.requirement.container_size_type.size < b.requirement.container_size_type.size) {
          return -1;
        } else if (a.requirement.container_size_type.size > b.requirement.container_size_type.size) {
          return 1;
        } else {
          return 0;
        }
      });
      this.dropoffTable.renderRows();
      this.containerSizesDropoff = [];
      this.containerSizesDropoff.push('All');
      this.getContainerSizeTypes(this.dropoffDataSource).map(item => this.containerSizesDropoff.push(item));
      console.log('this.requestService.dropoffScheduleListSubject', this.dropoffDataSource);
    });
  }

  applyPickupTableFilter(value) {
    this.pickupfilter = value;
    if (value != 'All')
      this.pickupDataSource.map(item => item.hideRow = value);
    else
      this.pickupDataSource.map(item => item.hideRow = item.requirement.container_size_type.display);
  }

  applyDropoffTableFilter(value) {
    this.dropofffilter = value;
    if (value != 'All')
      this.dropoffDataSource.map(item => item.hideRow = value);
    else
      this.dropoffDataSource.map(item => item.hideRow = item.requirement.container_size_type.display);
  }

  getContainerSizeTypes(dataSource) {
    const values = dataSource.map(item => item.requirement.container_size_type.display);
    const distinctValues = [...new Set(values)];
    return distinctValues;
  }

  editPickup(item) {
    item.isPEdit = true;
  }

  savePickupEdit(item) {
    if (item.total_permitted_quantity != null) {
      if (item.per_month_permitted_quantity > item.total_permitted_quantity) {
        this.openWarning('Total permitted quantity cannot be greater than avaliable Quantity', '', 'I Understand');
        item.total_permitted_quantity = null;
        return;
      }
    }
    item.isPEdit = false;
  }

  openWarning(label: string, description, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2 }
    });
  }

  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug('error object', this.errorObj);
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug('error object', this.errorObj);
      return error;
    }
  }

  editDropoff(item) {
    item.isDEdit = true;
  }

  saveDropoffEdit(item) {
    if (item.total_permitted_quantity != null) {
      if (item.per_month_permitted_quantity > item.total_permitted_quantity) {
        this.openWarning('Total permitted quantity cannot be greater than avaliable Quantity', '', 'I Understand');
        item.total_permitted_quantity = null;
        return;
      }
    }
    item.isDEdit = false;
  }

  addNewPickupSchedule() {
    this.editPS.emit({ quoteList: this.quoteList, pickupData: this.pickupDataSource });
  }

  addNewDropoffSchedule() {
    this.editDS.emit({ quoteList: this.quoteList, dropoffData: this.dropoffDataSource });
  }

  deletePickup(idx) {
    this.pickupDataSource.data = this.pickupDataSource.splice(idx, 1).slice();
    this.pickupTable.renderRows();
  }

  deleteDropoff(idx) {
    this.dropoffDataSource.data = this.dropoffDataSource.splice(idx, 1).slice();
    this.dropoffTable.renderRows();
  }

  isObject = (value: any) => typeof value === 'object';

}
